import React from 'react';

import PropTypes from 'prop-types';
import { TextInput } from '@telus-uds/components-web';

const FirstName = ({ fieldData, setFieldData, formErrors, setFormErrors }) => {
  return (
    <TextInput
      label="First Name *"
      value={fieldData.firstName}
      error={'firstName' in formErrors ? formErrors.firstName.message : undefined}
      onChange={(value) => {
        if (!value)
          setFormErrors({
            ...formErrors,
            firstName: { message: 'Field is required' }
          });
        else {
          const errors = { ...formErrors };
          delete errors.firstName;
          setFormErrors({
            ...errors
          });
        }
        setFieldData(previousValue => ({
          ...previousValue,
          firstName: value
        }));
      }}
    />
  );
};

FirstName.propTypes = {
  formErrors: PropTypes.shape({
    firstName: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default FirstName;
